// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCDeNPyoHJquZZxcJVoM7ilQIBJ87FGxGU",
  authDomain: "enlaceinmayjonny-91cf2.firebaseapp.com",
  projectId: "enlaceinmayjonny-91cf2",
  storageBucket: "enlaceinmayjonny-91cf2.appspot.com",
  messagingSenderId: "175613491438",
  appId: "1:175613491438:web:ebc2b9d2ca52a2138f9bff",
  measurementId: "G-95RDK3EFP6"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
